import { render, staticRenderFns } from "./Chronicle.vue?vue&type=template&id=2227e30b&scoped=true&class=Chronicle&style=height%3A100%25%3B"
import script from "./Chronicle.vue?vue&type=script&lang=js"
export * from "./Chronicle.vue?vue&type=script&lang=js"
import style0 from "./Chronicle.vue?vue&type=style&index=0&id=2227e30b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2227e30b",
  null
  
)

export default component.exports